import { FC } from "react";
import { Ticket, TicketType } from "../../../../components/TicketsPanel/Ticket";
import styles from '../ChallengeDetail.module.scss';

export interface IChallengeDetailTicketProgressProps {
    progress: number;
}

export const ChallengeDetailTicketProgress: FC<IChallengeDetailTicketProgressProps> = ({ progress }) => {
    return (
        <span className={styles.ticket}>
            <Ticket type={'rareTickets' as TicketType} value={progress}/>
        </span>
    );
}